// extracted by mini-css-extract-plugin
export default {"default":"keyboard-arrow_default__BC323"};